// A message for the login screen that survives the full page reload to /login — why the admin was sent there
// (the session ended, or their password changed). Kept in sessionStorage and shown once.

const STORAGE_KEY = 'authNotice';

export function setAuthNotice(message: string): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, message);
  } catch {
    // Storage unavailable (private mode): the toast before the redirect still shows it.
  }
}

export function consumeAuthNotice(): string | null {
  try {
    const message = window.sessionStorage.getItem(STORAGE_KEY);
    window.sessionStorage.removeItem(STORAGE_KEY);
    return message || null;
  } catch {
    return null;
  }
}
